import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { linkedAppsApi } from '../services/linkedAppsApi';
import type { WorkSites } from '../types/workSites';

const NONE: WorkSites = { allowed: false, sites: [] };

// 메뉴와 페이지가 같이 부르므로 사람마다 한 번만 묻는다
let cache: { userId: number; promise: Promise<WorkSites> } | null = null;

function load(userId: number): Promise<WorkSites> {
  if (cache?.userId !== userId) {
    cache = {
      userId,
      promise: linkedAppsApi.sites().catch(() => {
        cache = null; // 실패는 남기지 않는다 — 다음 화면에서 다시 묻는다
        return NONE;
      }),
    };
  }
  return cache.promise;
}

/** 「업무 사이트」 — 볼 수 있는가 · 연결 설정된 사이트. 판단은 백엔드가 한다(GET /api/sso/sites) */
export function useWorkSites(): WorkSites & { loading: boolean } {
  const { user } = useAuth();
  const userId = user?.id;
  const [state, setState] = useState<{ userId?: number; value: WorkSites } | null>(null);

  useEffect(() => {
    if (!userId) return;
    let alive = true;
    load(userId).then((value) => alive && setState({ userId, value }));
    return () => {
      alive = false;
    };
  }, [userId]);

  if (!userId) return { ...NONE, loading: false };
  if (!state || state.userId !== userId) return { ...NONE, loading: true };
  return { ...state.value, loading: false };
}
